module.exports = __webpack_public_path__ + "static/fonts/Quicksand-Medium.6080ccc.ttf";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/Quicksand-Medium.ttf
// module id = E5iy
// module chunks = 1